import _regeneratorRuntime from "@babel/runtime-corejs2/regenerator";
import _asyncToGenerator from "@babel/runtime-corejs2/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/esm/createClass";
import _defineProperty from "@babel/runtime-corejs2/helpers/esm/defineProperty";
import { SessionMarkActiveListenerServiceStrategy } from './SessionMarkActiveListenerServiceStrategy';
import { SessionManagerMarkActiveListenerStrategy } from '../types';
export var SessionMarkActiveListener = /*#__PURE__*/function () {
  function SessionMarkActiveListener(config) {
    _classCallCheck(this, SessionMarkActiveListener);

    _defineProperty(this, "strategy", void 0);

    switch (config.strategy) {
      case SessionManagerMarkActiveListenerStrategy.Service:
        this.strategy = new SessionMarkActiveListenerServiceStrategy(config);
        break;
    }
  }

  _createClass(SessionMarkActiveListener, [{
    key: "start",
    value: function () {
      var _start = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this$strategy;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", (_this$strategy = this.strategy) === null || _this$strategy === void 0 ? void 0 : _this$strategy.start());

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function start() {
        return _start.apply(this, arguments);
      }

      return start;
    }()
  }, {
    key: "stop",
    value: function () {
      var _stop = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _this$strategy2;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", (_this$strategy2 = this.strategy) === null || _this$strategy2 === void 0 ? void 0 : _this$strategy2.stop());

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function stop() {
        return _stop.apply(this, arguments);
      }

      return stop;
    }()
  }, {
    key: "update",
    value: function () {
      var _update = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var _this$strategy3;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", (_this$strategy3 = this.strategy) === null || _this$strategy3 === void 0 ? void 0 : _this$strategy3.update());

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function update() {
        return _update.apply(this, arguments);
      }

      return update;
    }()
  }]);

  return SessionMarkActiveListener;
}();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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